/* Nightpass - bloc de disponibilite : suit la variante selectionnee.

   Dawn ne publie pas les quantites dans son JSON produit ; le snippet ecrit
   donc sa propre table dans un <script type="application/json">. On y lit
   l'etat de la variante courante sans aucun appel reseau.

   Deux precautions, apprises d'un bug de decalage d'une variante :

   1. pubsub.js est charge en defer dans le <head>. Ce fichier doit donc l'etre
      aussi, sinon `subscribe` n'existe pas encore au moment ou l'on tente de
      s'y abonner, et l'abonnement est perdu silencieusement.

   2. Dawn applique 300 ms de debounce puis va chercher la section par le
      reseau avant de mettre a jour l'input [name=id]. Toute lecture a delai
      fixe renvoie l'ancienne variante. On interroge donc l'input par petites
      touches pendant quelques secondes, jusqu'a ce que la valeur se stabilise.

   Les libelles doivent rester identiques a ceux de np-stock.liquid : le
   serveur rend le premier etat, le client rend les suivants. */

(function () {
  if (window.__npStockReady) return;
  window.__npStockReady = true;

  var ICONS = {
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round"><path d="M5.5 12.4l4.3 4.3L18.5 8"/></svg>',
    clock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="8"/><path d="M12 7.6V12l3 1.8"/></svg>',
    cross: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"><path d="M7 7l10 10M17 7L7 17"/></svg>'
  };

  var SHIP_OK = 'Commande aujourd\'hui, <strong>ton colis part demain</strong>';

  var lastApplied = null;
  var poll = null;

  function badge() { return document.querySelector('[data-np-stock]'); }

  function table() {
    var node = document.querySelector('[data-np-stock-data]');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (e) { return null; }
  }

  function readId() {
    var el = document.querySelector('product-info [name="id"]')
          || document.querySelector('.product-form [name="id"]')
          || document.querySelector('form[action*="/cart/add"] [name="id"]');
    return el && el.value ? String(el.value) : null;
  }

  function apply(id) {
    if (!id || id === lastApplied) return;

    var box = badge();
    var data = table();
    if (!box || !data || !data[id]) return;

    var v = data[id];
    var low = parseInt(box.getAttribute('data-low'), 10) || 10;

    var state = 'in';
    var icon = ICONS.check;
    var title = 'En stock';
    var sub = SHIP_OK;

    if (!v.a) {
      state = 'out';
      icon = ICONS.cross;
      title = 'Rupture de stock';
      sub = 'Ce produit n\'est pas disponible pour le moment';
    } else if (v.m && v.q <= 0) {
      state = 'back';
      icon = ICONS.clock;
      title = 'Sur commande';
      sub = 'R\u00e9approvisionnement en cours, <strong>exp\u00e9dition diff\u00e9r\u00e9e</strong>';
    } else if (v.m) {
      if (v.q <= low) state = 'low';
      title = 'En stock : ' + v.q + ' restant' + (v.q > 1 ? 's' : '');
    }

    var elIco = box.querySelector('[data-np-stock-ico]');
    var elTitle = box.querySelector('[data-np-stock-title]');
    var elSub = box.querySelector('[data-np-stock-sub]');

    box.setAttribute('data-state', state);
    if (elIco) elIco.innerHTML = icon;
    if (elTitle) elTitle.textContent = title;
    if (elSub) elSub.innerHTML = sub;

    lastApplied = id;
  }

  /* Relit l'input a intervalles courts le temps que Dawn ait fini son
     debounce et son chargement de section. apply() ignore les valeurs deja
     appliquees, donc ces passages repetes ne coutent rien. */
  function settle() {
    var start = Date.now();
    clearInterval(poll);
    poll = setInterval(function () {
      apply(readId());
      if (Date.now() - start > 2500) clearInterval(poll);
    }, 100);
  }

  function boot() {
    /* Enregistre apres le chargement des scripts de Dawn : ce fichier est
       charge en defer, subscribe existe donc bien a ce stade. */
    try {
      if (typeof subscribe === 'function' &&
          typeof PUB_SUB_EVENTS !== 'undefined' &&
          PUB_SUB_EVENTS.variantChange) {
        subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
          if (event && event.data && event.data.variant) {
            apply(String(event.data.variant.id));
          }
          settle();
        });
      }
    } catch (err) {}

    document.addEventListener('change', function (e) {
      if (!e.target || !e.target.closest) return;
      if (e.target.closest('variant-selects, variant-radios, .product-form__input')) settle();
    });
    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      if (e.target.closest('variant-selects, variant-radios, .product-form__input')) settle();
    });
    window.addEventListener('popstate', settle);

    apply(readId());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
